<div
  class="wrapper wrapper-test"
  [style.height]="currentHeight()"
  id="map-component"
>
  <google-map
    [height]="'100%'"
    [width]="width()"
    [options]="currentOptions()"
    (mapClick)="onMapClick($event)"
    (mapDragstart)="onMapDragStart()"
    (mapInitialized)="mapInitialized.emit($event)"
    (mapRightclick)="onMapRightClick($event)"
    (maptypeidChanged)="onMapTypeIdChanged()"
  >
    @if (mapSettingsService.isClustered()) {
      <map-marker-clusterer (clusterClick)="onClusterClick($event)">
        <!-- Cartography BBX parts -->
        @for (b of bbx(); track b.id; let i = $index) {
          <map-advanced-marker
            #bbxMarker="mapAdvancedMarker"
            [position]="b.latLng()"
            [content]="b.content()"
            (mapClick)="onClickBbxMarker(i)"
          />
          <map-info-window
            #bbxInfoWindow="mapInfoWindow"
            [options]="infoWindowOptions()"
            (click)="onClickBbxInfoWindow(i)"
          >
            @if (currentBbxModel()) {
              <inf-details
                [model]="currentBbxModel()"
                [withIcon]="false"
                [data]="b"
              />
            }
          </map-info-window>
        }

        <!-- Cartography MATS parts -->
        @for (m of tags(); track m.id; let i = $index) {
          <map-advanced-marker
            #tagMarker="mapAdvancedMarker"
            [position]="m.latLng()"
            [content]="m.content()"
            (mapClick)="onClickTagMarker(i)"
          />
          <map-info-window
            #tagInfoWindow="mapInfoWindow"
            [options]="infoWindowOptions()"
            (click)="onClickTagInfoWindow(i)"
          >
            @if (currentTagModel()) {
              <inf-details
                [model]="currentTagModel()"
                [withIcon]="false"
                [data]="m"
              />
            }
          </map-info-window>
        }
      </map-marker-clusterer>
    } @else {
      <!-- Cartography BBX parts -->
      @for (b of bbx(); track b.id; let i = $index) {
        <map-advanced-marker
          #bbxMarker="mapAdvancedMarker"
          [position]="b.latLng()"
          [content]="b.content()"
          (mapClick)="onClickBbxMarker(i)"
        />
        <map-info-window
          #bbxInfoWindow="mapInfoWindow"
          [options]="infoWindowOptions()"
          (click)="onClickBbxInfoWindow(i)"
        >
          @if (currentBbxModel()) {
            <inf-details
              [model]="currentBbxModel()"
              [withIcon]="false"
              [data]="b"
            />
          }
        </map-info-window>
      }
      <!-- Cartography MATS parts -->
      @for (m of tags(); track m.id; let i = $index) {
        <map-advanced-marker
          #tagMarker="mapAdvancedMarker"
          [position]="m.latLng()"
          [content]="m.content()"
          (mapClick)="onClickTagMarker(i)"
        />
        <map-info-window
          #tagInfoWindow="mapInfoWindow"
          [options]="infoWindowOptions()"
          (click)="onClickTagInfoWindow(i)"
        >
          @if (currentTagModel()) {
            <inf-details
              [model]="currentTagModel()"
              [withIcon]="false"
              [data]="m"
            />
          }
        </map-info-window>
      }
    }

    <!-- Cartography Sites parts -->
    @for (s of sites(); track s.id; let i = $index) {
      @if (s.getType() === 'circle') {
        <map-circle
          [options]="s.circleOptions()"
          (circleClick)="onClickGeofenceCircle(i, $event)"
        />
      } @else if (s.getType() === 'polygon') {
        <map-polygon
          [options]="s.polygonOptions()"
          (polygonClick)="onClickGeofencePolygon(i, $event)"
        />
      }
    }

    <!-- AoPath part -->
    @if (aoPath()) {
      @for (polyline of aoPath().displayedPolyline; track polyline.id) {
        <map-polyline
          [options]="polyline.options"
          [path]="polyline.getLatLng()"
        />
      }

      @for (marker of aoPath().displayedMarkers; track marker.id) {
        <map-marker [position]="marker.latLng" [options]="marker.options" />
      }
    }

    <!-- Markers part -->
    @for (marker of markers(); track marker) {
      <map-marker
        [position]="marker.googleMapsLatLng()"
        [options]="marker.options"
      />
    }

    <!-- Geofence Circles part -->
    @for (circle of geofenceCircles(); track circle.id) {
      <map-circle
        [center]="circle.center.googleMapsLatLng()"
        [options]="circle.options"
        (circleDrag)="onCircleDrag($event, circle)"
        (circleDragend)="circleDragEnd.emit(circle)"
      />
    }
  </google-map>
</div>
@if ((showLegend() || showPlayer()) && aoPath()) {
  <div
    class="wrapper-detail"
    [ngClass]="{ 'with-player': showPlayer(), 'with-legend': showLegend() }"
  >
    @if (showPlayer()) {
      <div class="wrapper-player">
        <ao-shared-path-player
          [path]="aoPath()"
          (playEvent)="onPlayEvent($event)"
        />
      </div>
    }
    @if (showLegend()) {
      <div class="wrapper-legend">
        <ao-shared-legend-path />
      </div>
    }
  </div>
}
